import { gql } from '@common/hooks';

export const SimpleFileFragment = gql`
  fragment SimpleFileFragment on File {
    id
    filename
    createdAt
    downloadUrl
    previewUrl
    contentType
    size
  }
`;

export type SimpleFileFragmentType = {
  id: string;
  filename: string;
  createdAt: string;
  downloadUrl?: string | null;
  previewUrl?: string | null;
  contentType: string;
  size: string;
};
